import { render, staticRenderFns } from "./DownLoad.vue?vue&type=template&id=8e1d08b6&scoped=true&"
import script from "./DownLoad.vue?vue&type=script&lang=js&"
export * from "./DownLoad.vue?vue&type=script&lang=js&"
import style0 from "./DownLoad.vue?vue&type=style&index=0&id=8e1d08b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1d08b6",
  null
  
)

export default component.exports